/**
 * Reducer de Gamificação Avançada (XP, Level, Streak, Missions, Leaderboard).
 */

const initialState = {
  totalXp: 0,
  currentLevel: { level: 1, name: 'Bronze I', icon: 'fas fa-medal' },
  nextLevel: null,
  xpToNextLevel: 0,
  percentToNext: 0,
  globalPosition: 0,

  streak: { currentStreak: 0, longestStreak: 0, lastActivityDate: null },

  missions: [],
  leaderboard: [],
  topStreaks: [],
  levelList: [],
  xpEvents: [],

  loading: false
};

export default function gamification(state = initialState, action) {
  switch (action.type) {
    case 'SET_XP_PROGRESS':
      return {
        ...state,
        totalXp: action.data.totalXp || 0,
        currentLevel: action.data.currentLevel || state.currentLevel,
        nextLevel: action.data.nextLevel || null,
        xpToNextLevel: action.data.xpToNextLevel || 0,
        percentToNext: action.data.percentToNext || 0,
        globalPosition: action.data.globalPosition || 0
      };

    case 'SET_STREAK':
      return { ...state, streak: action.data || initialState.streak };

    case 'SET_MISSIONS':
      return { ...state, missions: action.data || [] };

    case 'SET_LEADERBOARD':
      return { ...state, leaderboard: action.data || [] };

    case 'SET_TOP_STREAKS':
      return { ...state, topStreaks: action.data || [] };

    case 'SET_LEVEL_LIST':
      return { ...state, levelList: action.data || [] };

    case 'SET_XP_EVENTS':
      return { ...state, xpEvents: action.data || [] };

    case 'SET_GAMIFICATION_LOADING':
      return { ...state, loading: !!action.data };

    default:
      return state;
  }
}
